<template>
    <div class="template-view has-header" v-bind:class="{'group-drag' : draggingGroup}">
        <div class="header">
            
            <b-row style="height: 55px">
                <b-col cols=1>
                   
                   <!--
                    <div class="fa-stack fa-custom-header refresh vertical-center" v-on:click="RefreshButton()">
                        <i class="fas fa-refresh fa-stack-2x"></i>
                    </div>
                    -->
                   
                </b-col>
                <b-col>
                     <b-row>
                        <div class="options center-horizontal">
                            <div class="label label-label">KW
                            </div>
                            <div class="label" v-on:click="currentSelectedWeek = weekIndex" v-for="weekIndex in currentYearWeeks" v-bind:key="weekIndex" v-bind:class="{'selected': currentSelectedWeek === weekIndex}">{{weekIndex}}</div>
                        </div> 
                       <!-- <b-form-select class="options event-select" v-model="selectedEventId">
                            <option v-bind:key="0" :value="null">Standardbesetzung</option>
                            <option v-for="event in eventDropDownItems" v-bind:key="event.id" :value="event.id">{{event.label}}</option>
                            
                        </b-form-select> -->
                    </b-row>
                     <b-row>
                        <div class="center-horizontal">
                            <div class="options">
                                <div class="label" v-on:click="templateDaySelection = 1, RefreshDisplayedTimeframes()" v-bind:class="{'selected': templateDaySelection === 1}">Mo</div>
                                <div class="label" v-on:click="templateDaySelection = 2, RefreshDisplayedTimeframes()" v-bind:class="{'selected': templateDaySelection === 2}">Di</div>
                                <div class="label" v-on:click="templateDaySelection = 3, RefreshDisplayedTimeframes()" v-bind:class="{'selected': templateDaySelection === 3}">Mi</div>
                                <div class="label" v-on:click="templateDaySelection = 4, RefreshDisplayedTimeframes()" v-bind:class="{'selected': templateDaySelection === 4}">Do</div>
                                <div class="label" v-on:click="templateDaySelection = 5, RefreshDisplayedTimeframes()" v-bind:class="{'selected': templateDaySelection === 5}">Fr</div>
                                <div class="label" v-on:click="templateDaySelection = 6, RefreshDisplayedTimeframes()" v-bind:class="{'selected': templateDaySelection === 6}">Sa</div>
                                <div class="label" v-on:click="templateDaySelection = 7, RefreshDisplayedTimeframes()" v-bind:class="{'selected': templateDaySelection === 7}">So</div>
                                <div class="label" v-on:click="templateDaySelection = 'W', RefreshDisplayedTimeframes()" v-bind:class="{'selected': templateDaySelection === 'W'}">W</div>
                                
                            </div>
                            <div class="options" v-if="templateDaySelection != 'W'">
                                <div class="label widelabel" v-for="(displayedTimeframe, indexD) in displayedTimeframes" v-bind:class="{'selected': displayedTimeframeSelected === displayedTimeframe}" :key="indexD"
                                    v-on:click="RefreshTimeFrame(displayedTimeframe)">{{displayedTimeframe.label}}h
                                </div>
                            </div>
                        </div>
                        
                    </b-row>
                   
                </b-col>
                <b-col cols=1>
                   
                </b-col>
            </b-row>
        </div>
        <b-row class ="text-center" style="height: 25px; top: 55px; position: relative">
                <b-col cols=1>
                    <!--
                    <div class="positions-filter button" v-on:click="OpenBusinessUnitFilterDropdown($event)">
                        <div class="label" style="padding-left: 3px; padding-top: 1px;">
                            <i class="fas fa-tasks"></i>
                        </div>
                    </div>

                    <div class="group-filter button" v-on:click="OpenShiftTemplateGroupFilterDropdown($event)">
                        <div class="label" style="padding-left: 4px; padding-top: 1px;">
                            <i class="fas fa-tasks"></i>
                        </div>
                    </div>
                    -->
                </b-col>
                <b-col style="color: var(--contrast-4);">

                    <strong style="color: #6d8d23"> {{currentYear}}</strong> {{titleDisplay}}

                </b-col>
                <b-col cols=1>
                </b-col>
        </b-row>
        <div class="scrollbar-container" v-bind:style="{height: embedded ? 'calc(100% - 80px) !important' : 'calc(100% - 135px) !important'}">
            
            <div class="grid">
                
                
                <div class="backdrop"></div>
                <div class="header">
                    
                    <div class="label">Schicht Templates </div>
                    <span class="fa-stack add" v-on:click="OpenNewShiftTemplateGroupPopup($event)">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-plus fa-stack-2x"></i>
                    </span>
                </div>
                <div v-for="(group, indexGroup) in templateDisplayGroups" :key="indexGroup">
                <div class="group" 
                     
                     v-bind:indexGroup="indexGroup"
                     v-bind:class="GetGroupClasses(group, indexGroup)">
                    <div class="header">
                        <div class="fa-stack drag" v-if="group.draggable" v-on:mousedown="DragStartBusinessUnit($event, group, indexGroup)">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-stack-2x fa-arrows-alt"></i>
                        </div>
                        <div class="label">{{group.header}}</div>
                        <div class="fa-stack add" v-on:click="OpenNewShiftTemplatePopup($event, group)">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-plus fa-stack-2x"></i>
                        </div>
                        <div class="fa-stack" v-on:click="group.collapsed = !group.collapsed">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-stack-2x" v-bind:class="{'fa-angle-down' : group.collapsed, 'fa-angle-up' : !group.collapsed}"></i>
                        </div>
                    </div>
                    <div class="bottom-line"></div>
                    <div class="drag-catch-area"></div>
                    <div class="drag-catch-area last"></div>
                    <div class="t-row" v-for="(template, indexE) in getTemplatesForDisplayGroup(group)" :key="indexE" v-if="!group.collapsed" >
                        <div class="templatedisplay">
                            <div class="picture" v-bind:style="{background: (template !== null ? template.picture : 'url(../img/default.jpg)'), 'background-size': 'contain'}"></div>
                            <div class="name">{{template.name}}
                                <span class="fa-stack remove" v-on:click="OpenDeleteShiftTemplatePopup($event, template.id)">
                                    <i class="fas fa-circle fa-stack-2x"></i>
                                    <i class="fas fa-minus fa-stack-2x"></i>
                                </span>
                            </div>
                            
                        </div>
                        <div class="timeframe" v-for="(timeFrame, indexF) in template.timeFrames" :key="indexF" v-bind:style="[GetTimeFrameStyles(timeFrame)]" v-bind:id="timeFrame.templateId"
                             v-on:mouseup="SelectTimeFrame($event, timeFrame)" v-bind:class="{'year-date-only': timeFrame.y}">
                            <div class="label start">{{timeFrame.fromDate.format('HH:mm')}}</div>
                            <div class="label end">{{timeFrame.toDate.format('HH:mm')}}</div>
                            <div class="handle end" v-on:mousedown="StartDragTimeFrame($event, timeFrame, false)"><div class="inner"></div></div>
                            <div class="handle start" v-on:mousedown="StartDragTimeFrame($event, timeFrame, true)"><div class="inner"></div></div>
                            <div class="handle end" v-on:mousedown="StartDragTimeFrame($event, timeFrame, false)"><div class="inner"></div></div>
                            
                        </div>
                        <div class="bottom-line"></div>
                    </div>
                    
                </div>
                
                </div>
                <div class="time-marks" v-bind:class="{'weekly': displayedTimeframeSelected.label === 'W'}" v-bind:style="{top: embedded ? '155px' : '210px'}">
                    <div class="mark" v-for="(mark, indexMark) in timeMarks" :key="indexMark" v-bind:style="[GetTimeMarkWidth(indexMark)]">
                        <div class="label">{{mark}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="event-info" v-if="eventOnHover">
            <div class="header">{{eventOnHover.header}}</div>
            <div class="description">{{eventOnHover.description}}</div>
        </div>
        <div class="drag-info" v-if="dragging">
            <div class="description">{{draggingTime.format('YYYY-MM-DD HHa')}}</div>
        </div>
        <div class="drag-group group" v-if="draggingGroup">
            <div class="header">
                <div class="fa-stack drag">
                    <i class="fas fa-stack-2x fa-arrows-alt"></i>
                </div>
                <div class="label">{{draggingGroup.header}}</div>
                <div class="fa-stack add">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-plus fa-stack-2x"></i>
                </div>
                <div class="fa-stack">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-stack-2x fa-angle-down"></i>
                </div>
            </div>
        </div>
        <div class="timeframe-popup" v-if="selectedTimeFrame" v-bind:style="{'left' : timeFramePopupOffsetX + 'px', 'top' : timeFramePopupOffsetY + 'px'}">
            <div class="background" v-on:click="selectedTimeFrame = null"></div>
            <div class="button" v-on:click="ApproveRequest(selectedTimeFrame)">
                <div class="label">Genehmigen</div>
            </div>
            <div class="button" v-on:click="DeclineRequest(selectedTimeFrame)">
                <div class="label">Ablehnen</div>
            </div>
        </div>
        <div v-if="loading" class="loading">
            <i class="fas fa-spinner"></i>
        </div>
        <dropdowncontainer ref="dropdowncontainer"/>
        <datepickerarray :state="datepickerarrayState" ref="datepickerarray" v-on:datepickerarray-dates-picked="datePickArrayCallback"></datepickerarray>
    </div>
</template>

<script>

    import dropdowncontainer from '../uicomponents/dropdowncontainer.vue'
    
    import datepickerarray from '../uicomponents/datepickerarray.vue'
    
    export default {
        name: 'templateview',
        components: {
            dropdowncontainer,
            datepickerarray,
        },
        data(){
            return{
                currentYear: this.$helpers.getMomentUTC().year(),
                currentSelectedWeek: this.$helpers.getMomentUTC().isoWeek(),
                displayedTimeframes:  [
                    {label: '6', length: 6 * 60 * 60 * 1000, divisions: 6},
                    {label: '12', length: 12 * 60 * 60 * 1000, divisions: 12},
                    {label: '24', length: 24 * 60 * 60 * 1000, divisions: 24},
                    {label: '36', length: 36 * 60 * 60 * 1000, divisions: 36},
                    {label: '48', length: 48 * 60 * 60 * 1000, divisions: 48}
                ],
                displayedTimeframeSelected: {label: '24', length: 24 * 60 * 60 * 1000, divisions: 24},
                eventOnHover: null,
                embedded: this.$route.name === "planning",
                mouseX: 0,
                mouseY: 0,
                timeMarks: [],
                businessUnits: [],
                businessUnitsMap: {},
                storeEventMap: {},
                selectedEventId: null,
                spotMap: {},
                mainSpotsForUnit: {},
                uiData: [],
                employeeAvailabilityStateMap: {},
                employeeAvailabilityTypeMap: {},
                selectedTimeFrame: null,
                timeFramePopupOffsetY: 0,
                timeFramePopupOffsetX: 0,
                loading: false,
                dragging: false,
                draggingTimeFrame: null,
                draggingStart: false,
                draggingStartPos: {x: 0, y: 0},
                draggingHandle: null,
                draggingGroup: null,
                groupCollapsedStates: {},
                userunitsort: [],
                spotVisibilityList: [],
                groupVisibilityList: [],
                skillVisibilityList: [],
                skills: [],
                skillMap: {},
                templateDaySelection: 'W',
                dayModeDate: this.$helpers.getMomentUTC(),
                shiftTemplateGroups: [],
                shiftTemplateGroupMap: {},
                shiftTemplateMap: {},
                shiftTemplates: [],
                shiftTemplateSkills: [],
                shiftTemplateSkillMap: {},
                datepickerarrayState: {
                    toggled: false,
                    monthView: false,
                    posx: 0,
                    posy: 0,
                    date: this.$helpers.getMomentUTC().month(0).date(1),
                    selectedDate: this.$helpers.getMomentUTC().month(0).date(1),
                    dateArray: [],
                    yearView: true,
                    noEdit: true,
                },
                yearDayFilter: [],
                datePickArrayCallback: function(dateArray){},

            }
        },
        props:{
            daySelected: Object,
            state: Object
        },
        watch: {
            state: {
                deep: true,
                immediate: true,
                handler(newVal, oldVal){ //newVal === oldVal
                   
                    if(newVal != null){
                        this.templateDaySelection = newVal.templateDaySelection;
                        if(this.templateDaySelection === 'W'){
                            this.displayedTimeframeSelected = {label: 'W', length: 7 * 24 * 60 * 60 * 1000, divisions: 7}
                        } else {
                            this.displayedTimeframeSelected = this.displayedTimeframes[2];
                        }
                        
                        if(newVal.embedded){
                            this.embedded = newVal.embedded;
                        }
                        
                        this.RefreshButton = newVal.RefreshButton;
                        this.RefreshDisplayedTimeframes();
                    } else {
                        this.displayedTimeframeSelected = this.displayedTimeframes[2];
                    }
                    
                }

            },
            storeId(newVal, oldVal) {
                //console.log("Changed storeId template view: "+newVal);
                this.Init();
            },
            loginStatus(newVal, oldVal) {
                //console.log("Changed login templateview");
                this.Init();

            },
           
        },
        computed: {
            loginStatus() {
                return this.$store.state.loggedIn;
            },
            storeId() {
                return this.$store.state.storeId;
            },
            currentWeekStart() {
                return this.$helpers.getMomentUTC().year(this.currentYear).isoWeek(this.currentSelectedWeek).startOf('isoWeek').hours(0).minutes(0);
            },
            currentYearWeeks() {
                return this.$helpers.getMomentUTC().year(this.currentYear).isoWeeksInYear();
            },
            timeFrameStart() {
                let timeFrameStart;
                if(this.templateDaySelection === 'W'){
                    timeFrameStart = this.currentWeekStart.startOf('isoWeek').hours(0).minutes(0);
                } else {
                    timeFrameStart = this.currentWeekStart.startOf('isoWeek').hours(0).minutes(0).add(this.templateDaySelection-1, 'days');
                }
                return timeFrameStart;
            },
            titleDisplay() {
                if(this.templateDaySelection === 'W'){
                    return "KW "+this.currentSelectedWeek+" "+this.timeFrameStart.format("DD.MMMM")+" - "+this.timeFrameStart.clone().add(7,'days').format("DD.MMMM");
                } else {
                    return "KW "+this.currentSelectedWeek+" "+this.timeFrameStart.format("DD.MMMM");
                }
            },
            weekStartTimes() {
                //precompute the dates of current selected Week for each weekday
                let weekStartTimes = [];
                for(let i = 0; i< 7;i++){
                    weekStartTimes.push(this.currentWeekStart.clone().add(i,'days'));
                }
                return weekStartTimes;23
            },

            eventDropDownItems() {
               return Object.entries(this.storeEventMap).map(entry => {
                    let item =  {
                        id: entry[1].id,
                        templateCount: this.shiftTemplates.filter(t => t.eventId == entry[1].id).length
                    }
                    item.label = entry[1].name+' '+ entry[1].fromMoment.format("DD.MM.YYYY")+' - '+entry[1].toMoment.format("DD.MM.YYYY");
                    return item;
                }).filter(e => e.templateCount > 0)

            },
            spots() {
                let view = this;
                let spots = Object.entries(this.spotMap).map(entry => entry[1]);
                
                return spots;
            },
            templateDisplayMap() {
                //this map depends in the weekStartTimes which change when currentWeekStart changes and on the selectedEventId
                let templateDisplayMap = {
                }

                let view = this;
                let templates = [];
                this.shiftTemplates.filter(t => t.eventId == this.selectedEventId).forEach(shiftTemplate =>{
                   
                    let compoundId = shiftTemplate.groupId+'-'+shiftTemplate.spotId;
                    if(!templateDisplayMap[compoundId]){
                        templateDisplayMap[compoundId] = [];
                    }

                    var shiftTemplateTemp = {};
                    shiftTemplateTemp.id = shiftTemplate.id;
                    shiftTemplateTemp.groupId = shiftTemplate.groupId;
                    shiftTemplateTemp.spotId = shiftTemplate.spotId;
                    shiftTemplateTemp.weekDays = shiftTemplate.weekDays;
                    shiftTemplateTemp.eventId = shiftTemplate.eventId;
                    shiftTemplateTemp.name = shiftTemplate.count +'x '+(shiftTemplate.spotId && shiftTemplate.spotId !== '' && view.spotMap[shiftTemplate.spotId] ? view.spotMap[shiftTemplate.spotId].name : 'Template');
                    shiftTemplateTemp.picture = 'url(../img/default.jpg)';
                    shiftTemplateTemp.timeFrames = [];
                    
                    
                        
                    shiftTemplate.weekDays.forEach(w => {
                        let fromDate = view.$helpers.getMomentFromStringUTC(this.weekStartTimes[w-1].format('YYYY-MM-DD') + 'T' + shiftTemplate.from, 'YYYY-MM-DDTHH:mmZ');
                        let toDate = view.$helpers.getMomentFromStringUTC(this.weekStartTimes[w-1].format('YYYY-MM-DD') + 'T' + shiftTemplate.to, 'YYYY-MM-DDTHH:mm');
                        
                        if(view.TimeDiff(fromDate, toDate) <= 0) toDate.add(1, 'days');

                        var timeFrame = {templateId: shiftTemplate.id, fromDate: fromDate, toDate: toDate, weekDay: w};
                        shiftTemplateTemp.timeFrames.push(timeFrame);
                        if(w === 7 && (timeFrame.fromDate.date() != timeFrame.toDate.date()))
                        {
                            timeFrame = {templateId: shiftTemplate.id, fromDate: fromDate.clone().add(w - 1, 'days').add(-1, 'week'), toDate: toDate.clone().add(w - 1, 'days').add(-1, 'week'), weekDay: 0};
                            shiftTemplateTemp.timeFrames.push(timeFrame);
                        }
                    });

                    templateDisplayMap[compoundId].push(shiftTemplateTemp);
                    templateDisplayMap[shiftTemplateTemp.id] = shiftTemplateTemp;
    
                });

                return templateDisplayMap;

            },
            templateDisplayGroups() {
                let view = this;
                let templateDisplayGroups  = [];
                //first only add main groups, already sorted by spot
                this.shiftTemplateGroups.forEach(group =>{
                    view.spots.forEach(spot =>{
                        if(spot.unitId == group.unitId && spot.isMain){
                            let isMain = spot.isMain;
                            let header = spot.name;
                            if(spot.isMain){
                                header = group.name+": "+spot.name;
                            }
                            let displaygroup = {id: group.id, header: header, collapsed: false, spot: spot, draggable: true, isMain: spot.isMain};
                           
                            displaygroup.shiftTemplateGroup = group;
                            if(this.spotVisibilityList.find(s => s.id === displaygroup.spot.id) && this.groupVisibilityList.find(g => g.id === displaygroup.id)) {
                                 templateDisplayGroups.push(displaygroup);
                            }
                           
                        }
                    })
                });
                //SORT MAIN GROUPS BY PRIORITY
                templateDisplayGroups.sort((a,b) => {
                    let userunitsortA = this.userunitsort.find(s => s.unitId === a.spot.unitId);
                    let userunitsortB = this.userunitsort.find(s => s.unitId === b.spot.unitId);
                    if( userunitsortA != null && userunitsortB != null){
                        return userunitsortA.priority - userunitsortB.priority
                    } else {
                        return a.header.localeCompare(b.header);
                    }
                });
                //CREATE SUB GROUPS
                let subGroups = [];
                this.shiftTemplateGroups.forEach(group =>{
                    view.spots.forEach(spot =>{
                        if(spot.unitId == group.unitId && !spot.isMain){
                            let isMain = spot.isMain;
                            let header = spot.name;
                            if(spot.isMain){
                                header = group.name+": "+spot.name;
                            }
                            let displaygroup = {id: group.id, header: header, collapsed: false, spot: spot, draggable: true, isMain: spot.isMain};
                           
                            displaygroup.shiftTemplateGroup = group;
                            if(this.spotVisibilityList.find(s => s.id === displaygroup.spot.id) && this.groupVisibilityList.find(g => g.id === displaygroup.id)) {
                                subGroups.push(displaygroup);
                            }
                           
                        }
                    })
                });
                //SORT SUB GROUPS BY PRIORITY
                subGroups.sort((a,b) => {
                    let userunitsortA = this.userunitsort.find(s => s.unitId === a.spot.unitId);
                    let userunitsortB = this.userunitsort.find(s => s.unitId === b.spot.unitId);
                    if( userunitsortA != null && userunitsortB != null){
                        return userunitsortA.priority - userunitsortB.priority
                    } else {
                        return a.header.localeCompare(b.header);
                    }
                });
                //SPLICE BY PARENT
                if(subGroups.length > 0) {
                    subGroups = subGroups.reverse();
                    subGroups.forEach(g => {
                        let parent = templateDisplayGroups.find(gm => gm.spot.isMain && gm.spot.unitId === g.spot.unitId && gm.id === g.id);
                        let parentIndex = templateDisplayGroups.indexOf(parent) + 1;
                        templateDisplayGroups.splice(parentIndex, 0, g);
                    });
                }
                

                return templateDisplayGroups;
            },
            timeFrameLength() {
                return this.displayedTimeframeSelected.length;
            }
        },
        created() {
            window.templateview = this;
           
            if(this.daySelected) {
                this.dayModeDate = this.daySelected.clone();
                this.templateDaySelection = this.daySelected.weekday() + 1;
            }
        },
        
        mounted() {
            this.embedded = this.$route.name != "planning";
            this.Init();
        },
        beforeDestroy(){

            if(this.$refs.datepickerarray && this.$refs.datepickerarray.$el) $(this.$refs.datepickerarray.$el).remove();
            if(this.$refs.dropdowncontainer && this.$refs.dropdowncontainer.$el) $(this.$refs.dropdowncontainer.$el).remove();
        },
        methods: {
            RefreshButton(){
                this.Init();
            },
            Init(){
                if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined && !this.loading){
                    var view = this;
                    this.loading = true;
                    view.loadUIData()
                    .then(response=> {
                        view.updateUIData(response.data);
                        return view.loadStoreEvents();
                    })
                    .then(response=> {
                        view.updateStoreEvents(response.data);
                        return view.loadSkills();
                    }).then(response => {
                        view.skills = response.data;
                        view.skillVisibilityList = [];
                        view.skillMap = {};
                        view.skills.forEach(s => view.skillMap[s.id] = s);
                        return view.loadShiftTemplateGroups();
                    }).then(response => {
                        view.shiftTemplateGroups = response.data;
                        view.shiftTemplateGroupMap = {};
                        view.shiftTemplateGroups.forEach(tg => view.shiftTemplateGroupMap[tg.id] = tg);
                        view.groupVisibilityList = [];
                        view.shiftTemplateGroups.forEach(g => view.groupVisibilityList.push(g));
                        let groupPayload = {ids: []};
                        for(let i = 0; i < response.data.length; i++){
                            groupPayload.ids.push(response.data[i].id);
                        }
                        return view.loadShiftTemplates(groupPayload);
                    }).then(response => {
                        view.GenerateShiftTemplates(response.data);
                        let templatePayload = {ids: []};
                        for(let i = 0; i < response.data.length; i++){
                            templatePayload.ids.push(response.data[i].id);
                        }
                        return view.loadShiftTemplateSkills(templatePayload);
                    }).then(response => {
                        view.shiftTemplateSkills = response.data;
                        view.shiftTemplateSkillsMap = {};
                        view.shiftTemplateSkills.forEach(ts => view.shiftTemplateSkillsMap[ts.id] = ts);
                        return  view.loadBusinessUnits();
                    }).then(response => {
                        view.businessUnits = response.data;
                        view.businessUnitsMap = {};
                        view.businessUnits.forEach(b => view.businessUnitsMap[b.id] = b);
                        return view.loadUserUnitSort();
                    }).then(response => {
                        view.updateUserUnitSort(response.data);
                        return view.loadSpots();
                    }).then(response => {
                        
                            
                        view.spotMap = {};
                        view.mainSpotsForUnit = {};
                        response.data.forEach(s => {
                            view.spotMap[s.id] = s
                            if(s.isMain){
                                view.mainSpotsForUnit[s.unitId] = s.id;
                            }
                        });
                        view.spotVisibilityList = [];
                        response.data.forEach(s => view.spotVisibilityList.push(s));
                    
                        view.RefreshDisplayedTimeframes();
                        view.loading = false;
                        
                        requestAnimationFrame(function(){
                            view.$forceUpdate();
                        });
                    }).catch(error => {
                        console.log(error);
                        view.loading = false;
                        view.$helpers.error('Fehler', 'Fehler beim Laden der Daten');
                    });
                }
                
            },
            getTemplatesForDisplayGroup(group){
                if(this.templateDisplayMap[group.id+'-'+group.spot.id]){
                    let result = this.templateDisplayMap[group.id+'-'+group.spot.id].filter(t => this.templateDaySelection === 'W' || t.weekDays.includes(this.templateDaySelection));
                    return result;
                } else {
                    return [];
                }
                
            },
            OpenNewShiftTemplatePopup($event, shiftTemplateGroup){
                var view = this;
                var from = this.dayModeDate.clone().hours(8).minutes(0);

                var to = this.dayModeDate.clone().hours(16).minutes(0);
                let eventtitems = [];
                Object.entries(this.storeEventMap).forEach(entry => {
                    let event = entry[1];
                    eventtitems.push({label: event.name+' '+event.fromMoment.format("DD.MM.YYYY")+' - '+event.toMoment.format("DD.MM.YYYY") , value: event.id});
                });
                var dataEntries = [
                    {label: 'Group Id', key: 'groupId', hidden: true, type: '', value: shiftTemplateGroup.id},
                    {label: 'Spot Id', key: 'spotId', hidden: true, type: '', value: shiftTemplateGroup.spot.id},
                    {label: 'Von', key: 'from', hidden: false, type: 'timeframe', value: from, hours: from.hours(), minutes: from.minutes()},
                    {label: 'Bis', key: 'to', hidden: false, type: 'timeframe', value: to, hours: to.hours(), minutes: to.minutes()},
                    {label: 'Anzahl', key: 'count', hidden: false, type: 'numeric', value: 1, min: 1, max: 10},
                    {label: 'Beschreibung', key: 'description', hidden: false, type: 'text', value: '', length: 20},
                    {label: 'Skill Multiplier', key: 'skillMultiplier', hidden: true, type: '', value: 1},
                    {label: 'Work Value Multiplier', key: 'workValueMultiplier', hidden: true, type: '', value: 1},
                    {label: 'Wochentage', key: 'weekDays', hidden: false, type: 'searchbar', value: null, selectMultiple: true, searchbar:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: [
                                {label:'Montag', value: 1},
                                {label:'Dienstag', value: 2},
                                {label:'Mittwoch', value: 3},
                                {label:'Donnerstag', value: 4},
                                {label:'Freitag', value: 5},
                                {label:'Samstag', value: 6},
                                {label:'Sonntag', value: 7},
                            ],
                            selectMultiple: true,
                            selectedItems: [],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                        }
                    },
                    {label: 'Event', key: 'eventId', hidden: false, type: 'searchbar', value: null, selectMultiple: false, searchbar:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: eventtitems,
                            selectMultiple: false,
                            selectedItems: [],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                    }},
                ];
                var target = $event.currentTarget;
                this.ToggleDataFill($event, {
                    header: 'Schicht Template',
                    dataEntries: dataEntries,
                    pointerDirection: 3,
                    posx: 0,
                    posy: 0,
                    elRelative: target,
                    selectCallback: function (shiftTemplate) {
                        view.CreateShiftTemplate(shiftTemplate);
                    }
                });

            },
            OpenNewShiftTemplateGroupPopup($event){
                var view = this;
                let bunititems = [];
                this.businessUnits.forEach(bunit => {
                    bunititems.push({label: bunit.name, value: bunit.id});
                });
                var dataEntries = [
                   
                    {label: 'Name', key: 'name', hidden: true, type: 'text', value: 'Default', length: 10},
                    {label: 'Beschreibung', key: 'description', hidden: false, type: 'text', value: '', length: 20},
                    {label: 'Bereich', key: 'unitId', hidden: false, type: 'searchbar', value: null, selectMultiple: false, searchbar:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: bunititems,
                            selectMultiple: false,
                            selectedItems: [],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                    }},
                    
                ];
                var target = $event.currentTarget;
                this.ToggleDataFill($event, {
                    header: 'Schicht Template Gruppe',
                    dataEntries: dataEntries,
                    pointerDirection: 3,
                    posx: 0,
                    posy: 0,
                    elRelative: target,
                    selectCallback: function (shiftTemplateGroup) {
                        view.CreateShiftTemplateGroup(shiftTemplateGroup);
                    }
                });

            },
            ToggleDataFill: function ($event, settings) {
                var box = $event.currentTarget.getBoundingClientRect();
                var target = $event.currentTarget;

                this.$refs.dropdowncontainer.Init({
                    elRelative: settings.elRelative,
                    data: settings.dataEntries,
                    header: settings.header,
                    currentComponent: 'datafill',
                    remainAfterSelect: false,
                    pointerOffset: (settings.pointerOffset && settings.pointerOffset !== 0) ? settings.pointerOffset : 15,
                    pointerDirection: (settings.pointerDirection && settings.pointerDirection !== 0) ? settings.pointerDirection : 0,
                    onceSelected: settings.selectCallback,
                });
            },
            CreateShiftTemplate: function(shiftTemplate){
                
                let view = this;
                let url = '/api/sec/shifttemplate';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shifttemplate');
                
                let payload = {
                    groupId: shiftTemplate.groupId,
                    from: view.$helpers.getMomentFromStringUTC(shiftTemplate.from).format('HH:mmZ'),
                    to: view.$helpers.getMomentFromStringUTC(shiftTemplate.to).format('HH:mmZ'),
                    spotId: shiftTemplate.spotId,
                    eventId: shiftTemplate.eventId ? shiftTemplate.eventId : null,
                    count: shiftTemplate.count,
                    description: shiftTemplate.description,
                    skillMultiplier: 1,
                    workValueMultiplier:1,
                    workValue: -1,
                    holidayWorkValue: -1,
                    weekDays: shiftTemplate.weekDays ? shiftTemplate.weekDays : [],
                   
                }
               

                this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.$helpers.success('Erstellen erfolgreich', 'Schicht Template wurder erfolgreich erstellt')
                    view.Init();
                }).catch(function (error) {
                    view.$helpers.error('Erstellen fehlgeschlagen', 'Fehler beim Erstellen des Schicht Templates');
                })

            },
            CreateShiftTemplateGroup: function(shiftTemplateGroup){
                
                let view = this;
                let url = '/api/sec/shifttemplategroup';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shifttemplategroup');
                
                let payload = {
                    name: shiftTemplateGroup.name,
                    unitId: shiftTemplateGroup.unitId,
                    description: shiftTemplateGroup.description,
                }
               

                this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.$helpers.success('Erstellen erfolgreich', 'Schicht Template Gruppe wurde erfolgreich erstellt')
                    view.Init();
                }).catch(function (error) {
                    view.$helpers.error('Erstellen fehlgeschlagen', 'Fehler beim Erstellen der Schicht Template Gruppe');
                })

            },
            GenerateShiftTemplates(templateData){
                var view = this;
                view.shiftTemplates = templateData;
                view.shiftTemplateMap = {};
                view.shiftTemplates.forEach(s => view.shiftTemplateMap[s.id] = s);

            },
            SwitchTemplateDay(){

            },
            GetGroupClasses(group, indexGroup){
                return {
                    'sub-spot': group.spot && !group.spot.isMain,
                    'group-dragged': group === this.draggingGroup,
                    'show-drag-area': this.draggingGroup && this.draggingGroup.spot && group.spot &&                                              // make sure you're dragging and the spots are set
                        ((this.draggingGroup.spot.isMain && group.spot.isMain) ||                                                                 // if you're dragging a main group then the subgroups shouldn't show their drag areas
                            (!this.draggingGroup.spot.isMain && !group.spot.isMain && group.spot.unitId == this.draggingGroup.spot.unitId && group.spot)), // if you're dragging a subgroup then only show the drag areas of the same parent
                    'show-drag-area-last': this.draggingGroup && (indexGroup === this.templateDisplayGroups.length - 1 ||                                     // this is for dragging in front of a group but only the last one should have it
                        // but for subgroups we have to get the last subgroup which I'll do by asking if the next one is a main group (wip)
                        (!this.draggingGroup.spot.isMain && this.draggingGroup !== group && group.spot.unitId === this.draggingGroup.spot.unitId && indexGroup + 1 !== this.templateDisplayGroups.length && this.templateDisplayGroups[indexGroup + 1].spot.isMain))}
            },
            DragStartBusinessUnit: function ($event, templateGroup,indexGroup){
                var view = this;
                setTimeout(function(){
                    if(!window.mouse.click) return;

                    view.groupCollapsedStates = {};
                    view.templateDisplayGroups.forEach(g => view.groupCollapsedStates[g.header] = g.collapsed);

                    for(let x in view.templateDisplayGroups){
                        view.templateDisplayGroups[x].collapsed = true;
                        if(view.templateDisplayGroups[x].spot == null || view.templateDisplayGroups[x].spot.id === templateGroup.spot.id){
                            view.templateDisplayGroups[x].show = false;
                        }else{
                            view.templateDisplayGroups[x].show = true;
                        }
                    }

                    view.draggingGroup = templateGroup;
                    view.DragBusinessUnitWatch();
                }, 500);
            },
            DragBusinessUnitWatch(){
                var view = this;
                if($(this.$el).find('.drag-group').length > 0) $(this.$el).find('.drag-group').css({left: (window.mouse.x - ($(this.$el).find('.drag-group')[0].getBoundingClientRect().width * .025)) + 'px', top: (window.mouse.y - ($(this.$el).find('.drag-group')[0].getBoundingClientRect().height * .5)) + 'px'});


                view.$forceUpdate();
                requestAnimationFrame(function(){
                    if(window.mouse.click) view.DragBusinessUnitWatch();
                    else {
                        requestAnimationFrame(function(){
                            view.EndDragBusinessUnit();
                        });
                    }
                });
            },
            EndDragBusinessUnit(){
                var view = this;
                var elementInGroup = $(this.$el).find('.grid > .group .drag-catch-area').toArray().find(e => { //in all the current group drag areas check if the mouse is inside of it
                    var box = e.getBoundingClientRect();
                    return box.left < window.mouse.x && box.right > window.mouse.x && box.top < window.mouse.y && box.bottom > window.mouse.y;
                });
                if(elementInGroup) {
                    var groupDroppedOverIndex = $(elementInGroup).closest('.group').attr('indexgroup');
                    var groupDroppedOver = this.templateDisplayGroups[groupDroppedOverIndex];
                    var insertIndexMain = this.templateDisplayGroups.indexOf(groupDroppedOver);
                    if($(elementInGroup).hasClass('last')) insertIndexMain++;
                    
                    
                    var sortData = [];
                    this.templateDisplayGroups.forEach(g => sortData.push({unitId: g.spot.id, priority: view.templateDisplayGroups.indexOf(g)}));
                    this.SendBusinessUnitsPriorityUpdate(sortData);
                }
                this.$forceUpdate();
                requestAnimationFrame(function() {
                    view.draggingGroup = null;
                    for (var x in view.groupCollapsedStates) {
                        var group = view.templateDisplayGroups.find(g => g.header === x);
                        if (group) group.collapsed = view.groupCollapsedStates[x];
                    }
                });
            },
            
            
            SelectTimeFrame($event, timeFrame){
                return;
                if(this.dragging) return;
                if(this.selectedTimeFrame) this.selectedTimeFrame = null;
                if(!this.selectedTimeFrame){
                    this.selectedTimeFrame = timeFrame;
                    var target = $event.currentTarget;
                    var box = $event.currentTarget.getBoundingClientRect();
                    this.timeFramePopupOffsetX = box.left + (box.width * .5) - (80); // last var is width of popup
                    this.timeFramePopupOffsetY = box.top + box.height + 15;

                }
            },
            ApproveRequest(timeFrame){},
            DeclineRequest(timeFrame){},
            EventMouseTrack(){
                if($(window.mouse.element).hasClass('event') || $(window.mouse.element).closest('.event').length > 0){
                    this.mouseX = window.mouse.x;
                    this.mouseY = window.mouse.y + 20;
                    $(this.$el).find('.event-info').css({left: (this.mouseX - ($(this.$el).find('.event-info')[0].getBoundingClientRect().width * .5)) + 'px', top: this.mouseY + 'px'});
                } else {
                    this.eventOnHover = null;
                }

            },
            GetColorForType(typeId){
                if(typeId === 1) return '#e76e13'; //vacation
                if(typeId === 2) return '#e51650'; //sickness
                if(typeId === 3) return '#e5c420'; //holiday
                if(typeId === 4) return '#7e1433'; //miscellaneous
                if(typeId === 4) return '#808080'; //no contract
            },
            GetColorForState(stateId){
                if(stateId === 1) return '#e51650'; //unavailable
                if(stateId === 2) return '#294285'; //only available
                if(stateId === 3) return '#ff1655'; //undesired
                if(stateId === 4) return '#aace27'; //desired
            },
            OnDateArrayPicked(){

            },
            
            OpenYearDays($event, timeFrame){
                var box = $event.currentTarget.getBoundingClientRect();
                this.datepickerarrayState = {
                    toggled: true,
                    monthView: false,
                    posx: box.right + 15,
                    posy: box.top,
                    date: this.$helpers.getMomentUTC().month(0).date(1),
                    selectedDate: this.$helpers.getMomentUTC().month(0).date(1),
                    dateArray: timeFrame.shiftTemplate.yearDays.slice(),
                    yearView: true,
                    noEdit: true,
                };
            },
            StartDragTimeFrame($event, timeFrame, isStart){
                var view = this;
                this.dragging = true;
                this.draggingStart = isStart;
                this.draggingTimeFrame = timeFrame;
                this.draggingTimeInit = isStart ? timeFrame.fromDate.clone() : timeFrame.toDate.clone();
                this.draggingStartPos = {x: window.mouse.x, y: window.mouse.y};
                this.draggingHandle = $event.currentTarget;
                this.DragWatch();
            },
            DragWatch(){
                var view = this;
                var time = view.draggingTime = view.draggingStart ? view.draggingTimeFrame.fromDate : view.draggingTimeFrame.toDate;
                var timeLimit = !view.draggingStart ? view.draggingTimeFrame.fromDate : view.draggingTimeFrame.toDate;
                if($(this.$el).find('.drag-info').length > 0) $(this.$el).find('.drag-info').css({left: (window.mouse.x - ($(this.$el).find('.drag-info')[0].getBoundingClientRect().width * .5)) + 'px', top: (this.draggingHandle.getBoundingClientRect().top - 45)+ 'px'});
                var totalWidth = $(this.$el).find('.grid').width() - 225;
                var timePixelRatio = totalWidth / this.timeFrameLength;

                var delta = window.mouse.x - this.draggingStartPos.x;
                var deltaTime = this.draggingTimeInit.clone().add(delta / timePixelRatio, 'milliseconds');
                time.year(deltaTime.year());
                time.month(deltaTime.month());
                time.date(deltaTime.date());
                time.hours(deltaTime.hours());
                time.minutes(parseInt(deltaTime.minutes() / 5) * 5);
                time.seconds(0);
                time.milliseconds(0);
                
                    //flatten display arrays to array of templates, then filter where templateId matches draggingTimeFrame.tamplateId and change alle timeframes of it
                    if(this.templateDisplayMap[view.draggingTimeFrame.templateId]){
                        this.templateDisplayMap[view.draggingTimeFrame.templateId].timeFrames.forEach(t => {
                            
                            var timeTemp = view.draggingStart ? t.fromDate : t.toDate;
                            timeTemp.year(time.year());
                            timeTemp.month(time.month());
                            timeTemp.date(time.clone().add(t.weekDay - view.draggingTimeFrame.weekDay, 'days').date());
                            timeTemp.hours(time.hours());
                            timeTemp.minutes(parseInt(deltaTime.minutes() / 5) * 5);
                        });
                    }
                
                view.$forceUpdate();
                requestAnimationFrame(function(){
                    if(window.mouse.click) view.DragWatch();
                    else {
                        view.dragging = false;
                        requestAnimationFrame(function(){
                            view.EndDragTimeFrame();
                        });
                    }
                });
            },
            EndDragTimeFrame(){
                this.UpdateShiftTemplate(this.draggingTimeFrame.templateId, this.draggingTimeFrame.fromDate, this.draggingTimeFrame.toDate, function(response){console.log(response)});
            },
            RefreshDisplayedTimeframes(){
                if(this.templateDaySelection ===  'W'){
                    let weekTimeFrame = {label: 'W', length: 7 * 24 * 60 * 60 * 1000, divisions: 7}
                    this.displayedTimeframeSelected = weekTimeFrame;
                } else if(this.displayedTimeframeSelected.label === 'W'){
                    this.displayedTimeframeSelected = this.displayedTimeframes[2];   
                } /*else {
                    this.displayedTimeframeSelected = this.displayedTimeframes.find(t => t.label === this.displayedTimeframeSelected.label);
                } */

                this.GetTimeMarks();
                this.$forceUpdate();
            },
            OpenYearDayFilterPopup($event){
                var view = this;

                var box = $event.currentTarget.getBoundingClientRect();
                this.datepickerarrayState = {
                    toggled: true,
                    monthView: false,
                    posx: box.right + 15,
                    posy: box.top,
                    date: this.$helpers.getMomentUTC().month(0).date(1),
                    selectedDate: this.$helpers.getMomentUTC().month(0).date(1),
                    dateArray: view.yearDayFilter.slice(),
                    yearView: true,
                    noEdit: false,
                    CountMap: function(index, month){
                        if(!month) return 0;
                        var date = view.$helpers.getMomentUTC().date(index).month(month - 1);
                        var yearDay = date.dayOfYear();
                        return view.shiftTemplates.filter(t => t.yearDays.find(d => yearDay === d)).length;
                    },
                };
                view.datePickArrayCallback = function(dateArray){
                    view.yearDayFilter = dateArray;
                    view.RefreshDisplayedTimeframes();
                };
            },
            
            
            OpenBusinessUnitFilterDropdown($event){
                var view = this;
                var target = $event.currentTarget;

                var list = [];
                this.spots.forEach(s => list.push({label: s.name, toggled: (view.spotVisibilityList.find(p => s === p)) ? true : false, spot: s,
                    styles: s.isMain ? [] : [{'margin-left' : '30px'}]
                }));
                this.$refs.dropdowncontainer.Init({
                    el: target,
                    elRelative: target,
                    items: list,
                    currentComponent: 'list',
                    header: 'Arbeitsbereiche Ein-/Ausblenden',
                    expanded: true,
                    remainAfterSelect: true,
                    pointerOffset: 15,
                    pointerDirection: 3,
                    iconsLeft: true,
                    onceSelected: function($event, item, dropdown){
                        item.toggled = !item.toggled;
                        if(item.toggled) {
                            if (!item.spot.isMain) {
                                dropdown.items.filter(i => !i.toggled && i.spot.unitId === item.spot.unitId && i.spot.isMain).forEach(i => {
                                    i.toggled = true;
                                    view.spotVisibilityList.push(i.spot);
                                });
                            }
                            view.spotVisibilityList.push(item.spot);
                        }
                        else {
                            view.spotVisibilityList = view.spotVisibilityList.filter(s => s !== item.spot);
                            if (item.spot.isMain) {
                                dropdown.items.filter(i => i.spot.unitId === item.spot.unitId).forEach(i => i.toggled = false);
                                view.spotVisibilityList = view.spotVisibilityList.filter(s => s.unitId !== item.spot.unitId);
                            }
                        }
                    },
                });
            },

            OpenShiftTemplateGroupFilterDropdown($event){
                var view = this;
                var target = $event.currentTarget;

                var list = [];
                this.shiftTemplateGroups.forEach(g => list.push({label: g.name+': '+view.spotMap[view.mainSpotsForUnit[g.unitId]].name, toggled: (view.groupVisibilityList.find(p => g === p)) ? true : false, group: g,
                    styles: []
                }));
                this.$refs.dropdowncontainer.Init({
                    el: target,
                    elRelative: target,
                    items: list,
                    currentComponent: 'list',
                    header: 'Template Gruppen Ein-/Ausblenden',
                    expanded: true,
                    remainAfterSelect: true,
                    pointerOffset: 15,
                    pointerDirection: 3,
                    iconsLeft: true,
                    onceSelected: function($event, item, dropdown){
                        item.toggled = !item.toggled;
                        if(item.toggled) {
                            
                            view.groupVisibilityList.push(item.group);
                        }
                        else {
                            view.groupVisibilityList = view.groupVisibilityList.filter(g => g !== item.group);
                            
                        }
                    },
                });
            },
            GetTimeMarks(){
                var marks = [];
                let weekdays = this.$helpers.getMoment().weekdays();
                for(var x = 0; x < this.displayedTimeframeSelected.divisions; x++){
                    var timemark = (x > 9 ? x : '0' + x);

                    if(this.displayedTimeframeSelected.length <= 48 * 60 * 60 * 1000) timemark = ((x % 24) > 9 ? (x % 24) : '0' + (x % 24));
                    if(this.displayedTimeframeSelected.label === 'W') timemark = weekdays[(x + 1) % 7];

                    marks.push(timemark.toString());
                }

                this.timeMarks = marks;
            },
            GetTimeMarkWidth(index) {
                
                return {width: ($(this.$el).find('.time-marks').width() / parseInt(this.displayedTimeframeSelected.divisions)) + 'px'};
            },
            RefreshTimeFrame(displayedTimeframe){
                this.displayedTimeframeSelected = displayedTimeframe;
                this.GetTimeMarks();
                this.RefreshDisplayedTimeframes();
            },
            GetTimeFrameStyles(timeFrame){
                var totalWidth = $(this.$el).find('.time-marks').width();
                var timePixelRatio = totalWidth / this.timeFrameLength;
                var background = '#e5e5e5';
                if(timeFrame.y) background = '#e86e13';
                var styles = {
                    width: (this.TimeDiff(timeFrame.fromDate, timeFrame.toDate) * timePixelRatio) + 'px',
                    left: (this.TimeDiff(this.timeFrameStart, timeFrame.fromDate) * timePixelRatio) + 'px',
                    background: background,
                };
                return styles;
            },
            TimeDiff(a, b){
                return (parseInt(b.format('x'))) - (parseInt(a.format('x')));
            },
            GetProfilePictureUrl(employee){
                if(!employee || !employee.employeePicture || !employee.employeePicture.server) return 'var(--contrast-1) no-repeat center/cover  url(../img/default.jpg)';
                var d = new Date();
                return 'var(--contrast-1) no-repeat center/cover  url(' + employee.employeePicture.server + '/api/file?id='+ employee.employeePicture.fileId +'&accessToken='+employee.employeePicture.accessToken +"&thumb=small"+ '&time='+Date.now()+')';
            },
            WeeksInMonth(moment) {
                var temp = moment.clone();

                var first = temp.startOf('month').week();
                var last = temp.endOf('month').week();

                if( first > last) {
                    last = first + last;
                }
                return last - first + 1;
            },
            sortByName: function(a,b){
                var x = a.firstName + " " + a.lastName;
                var y = b.firstName + " " + b.lastName;
                if ( x.toUpperCase() < y.toUpperCase() ) return -1;
                if ( x.toUpperCase() > y.toUpperCase() ) return 1;
                return 0;
            },
            loadUIData: function(){
                let url = '/api/semi/uidata';
                return this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                });
            },
            updateUIData: function(data){
                this.uiData = data;
                let stateMap =  {};
                let typeMap = {};
                for(let i = 0; i < data.employeeAvailabilityStates.length; i++){
                    let employeeAvailabilityState = data.employeeAvailabilityStates[i];
                    stateMap[employeeAvailabilityState.id] = employeeAvailabilityState;
                    employeeAvailabilityState.show = true;
                }
                for(let i = 0; i < data.employeeAvailabilityTypes.length; i++){
                    let employeeAvailabilityType = data.employeeAvailabilityTypes[i];
                    typeMap[employeeAvailabilityType.id] = employeeAvailabilityType;
                    employeeAvailabilityType.show = true;
                }
                this.employeeAvailabilityStates = data.employeeAvailabilityStates;
                this.employeeAvailabilityTypes = data.employeeAvailabilityTypes;
                this.employeeAvailabilityStateMap = stateMap;
                this.employeeAvailabilityTypeMap = typeMap;
            },
            loadBusinessUnits : function() {

                let url = '/api/sec/businessunit';

                let params = {
                    storeId: this.$store.state.storeId,
                };


                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })


            },
            loadSpots : function() {

                let url = '/api/sec/spot';

                let params = {
                    storeId: this.$store.state.storeId,
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })


            },
            OpenDeleteShiftTemplatePopup(event, templateId){
                let view = this;
                window.app.popupalerts.push({header: 'Schicht Template löschen', description: 'Schicht Template wirklich löschen?', callbackAccept: function(popup){
                        popup.loading = true;
                        let url = '/api/sec/shifttemplate';
                        let params = {
                            storeId: view.$store.state.storeId,
                            id: templateId
                        }
                        view.axios({
                            method: 'delete',
                            params: params,
                            headers: {
                                'AUTHORIZATION': "bearer "+view.$store.state.jwt
                            },
                            url: url,
                        }).then(response => {
                            popup.loading = false;
                            popup.hidden = true;
                            view.$helpers.success('Löschen erfolgreich', 'Schicht Template wurde gelöscht')
                            view.Init()
                            
                        }).catch(function (error) {
                            popup.loading = false;
                            view.$helpers.error('Löschen fehlgeschlagen', 'Fehler beim Löschen des Schicht Templates');
                        });
                    }, callbackCancel: function(popup){
                        popup.loading = false;
                        popup.hidden = true;
                        
                    }});
            },
            UpdateShiftTemplate(templateId, fromDate, toDate){
                let view = this;
                window.app.popupalerts.push({header: 'Affect Linked Shifts', description: 'Affect future linked shifts by the change?', callbackAccept: function(popup){
                        popup.loading = true;
                        let url = '/api/sec/shifttemplate';
                        url = view.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/shifttemplate');
                        let payload = {
                            storeId: view.$store.state.storeId,
                            id: templateId,
                            updateFields: []
                        }
                        var fields = {};
                        fields['from'] = view.$helpers.convertDateTimeString(null, fromDate);
                        fields['to'] = view.$helpers.convertDateTimeString(null, toDate);
                        fields['id'] = templateId;
                        fields['updateShifts'] = true;
                        for(var x in fields){
                            var field = fields[x];
                            payload[x] = field;
                            payload.updateFields.push(x);
                        }

                        view.axios({
                            method: 'put',
                            headers: {
                                'AUTHORIZATION': "bearer "+view.$store.state.jwt
                            },
                            url: url,
                            data: payload
                        }).then(response => {
                            popup.loading = false;
                            popup.hidden = true;
                            const index = view.shiftTemplates.findIndex(stemplate => stemplate.id === templateId) 
                            if (~index) {
                                view.shiftTemplates[index].from = payload.from;
                                view.shiftTemplates[index].to = payload.to;
                            } 
                            view.$set(view.shiftTemplateMap[templateId], 'from', payload.from);
                            view.$set(view.shiftTemplateMap[templateId], 'to', payload.to);
                            view.$helpers.success('Update erfolgreich', 'Schicht Template wurde aktualisiert')
                        }).catch(function (error) {
                            popup.loading = false;
                            view.$helpers.error('Update fehlgeschlagen', 'Fehler beim Update des Schicht Templates');
                        });
                    }, callbackCancel: function(popup){
                        popup.loading = true;
                        let url = '/api/sec/shifttemplate';
                        url = view.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/shifttemplate');
                        let payload = {
                            storeId: view.$store.state.storeId,
                            id: templateId,
                            updateFields: []
                        }
                        var fields = {};
                        fields['from'] = view.$helpers.convertDateTimeString(null, fromDate);
                        fields['to'] = view.$helpers.convertDateTimeString(null, toDate);
                        fields['id'] = templateId;
                        fields['updateShifts'] = false;
                        for(var x in fields){
                            var field = fields[x];
                            payload[x] = field;
                            payload.updateFields.push(x);
                        }
                        view.axios({
                            method: 'put',
                            headers: {
                                'AUTHORIZATION': "bearer "+view.$store.state.jwt
                            },
                            url: url,
                            data: payload
                        }).then(response => {
                            popup.loading = false;
                            popup.hidden = true;
                            const index = view.shiftTemplates.findIndex(stemplate => stemplate.id === templateId) 
                            if (~index) {
                                view.shiftTemplates[index].from = payload.from;
                                view.shiftTemplates[index].to = payload.to;
                            } 
                            view.$set(view.shiftTemplateMap[templateId], 'from', payload.from);
                            view.$set(view.shiftTemplateMap[templateId], 'to', payload.to);
                            view.$helpers.success('Update erfolgreich', 'Schicht Template wurde aktualisiert')
                        }).catch(function (error) {
                            popup.loading = false;
                            popup.hidden = true;
                            view.$helpers.error('Update fehlgeschlagen', 'Fehler beim Update des Schicht Template');
                        });
                    }});
            },
            SendBusinessUnitsPriorityUpdate: function(data){
                let view = this;
                let url = '/api/sec/userunitsortupdate';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/userunitsortupdate');
                let payload = {
                    data: data
                }
                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.$helpers.success('Gespeichert', 'Die neue Reihenfolge wurde gespeichert!');
                }).catch(function (error) {
                    view.$helpers.warning('Fehler', 'Speichern fehlgeschlagen!');
                    view.error=true;
                    console.log(error)
                })
            },

            loadUserUnitSort : function() {

                let url = '/api/sec/userunitsort';

                let params = {
                    storeId: this.$store.state.storeId,
                };
                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })
            },
            updateUserUnitSort: function(data){
                let userunitsort = []
                for (let i = 0; i < data.length; i++) {
                    userunitsort.push(data[i]);
                }
                this.userunitsort = userunitsort;
            },
            sortByPriorityAndName: function(a,b){
                if ( a.priority < b.priority ) return -1;
                if ( a.priority > b.priority ) return 1;
                if ( a.name.toUpperCase() < b.name.toUpperCase() ) return -1;
                if ( a.name.toUpperCase() > b.name.toUpperCase() ) return 1;
                return 0;
            },
            loadSkills : function() {

                let url = '/api/sec/skill';

                let params = {
                    storeId: this.$store.state.storeId,
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })


            },
            loadShiftTemplateGroups() {

                let url = '/api/sec/shifttemplategroup';

                let params = {
                    storeId: this.$store.state.storeId,
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })

            },
            loadShiftTemplateSkills : function(payload) {
                if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
                    return new Promise((resolve, reject) => {
                        resolve({data:[]});
                    })
                } else {
                    let url = '/api/sec/shifttemplateskillrequirement/any/template';

                    let params = {
                        storeId: this.$store.state.storeId,
                    };

                    return this.axios({
                        method: 'post',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    })
                }
            },
            updateShiftTemplateSkills: function(data){

                let map = {};

                for (let i = 0; i < data.length; i++) {
                    map[data[i].id] = data[i];
                    if(this.shiftTemplateMap[data[i].templateId] != undefined){
                        if(this.shiftTemplateMap[data[i].templateId].requiredSkills == undefined){
                            this.shiftTemplateMap[data[i].templateId].requiredSkills = []
                        }
                        this.shiftTemplateMap[data[i].templateId].requiredSkills.push(data[i].id);
                    }
                }
                this.shiftTemplateSkillMap = map;
            },
            loadShiftTemplates : function(payload) {
                if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
                    return new Promise((resolve, reject) => {
                        resolve({data:[]});
                    })
                } else {
                    let url = '/api/sec/shifttemplate/any/group';

                    let params = {
                        storeId: this.$store.state.storeId,
                    };

                    return this.axios({
                        method: 'post',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    })
                }
            },
            updateShiftTemplateGroups : function(data){
                let map = {};
                for (let i = 0; i < data.length; i++) {
                    map[data[i].id] = data[i];
                }
                this.shiftTemplateGroupMap = map;
            },
            loadStoreEvents: function() {
                let url = '/api/sec/storeevent';
                let params = {
                    storeId: this.$store.state.storeId,
                    active: true,
                };
                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                });
            },
            updateStoreEvents: function(data){
                let i;
                let tstoreevents = {}
                for (i = 0; i < data.length; i++) {
                    let item = data[i];
                    item.fromMoment = this.$helpers.getMomentFromString(item.from);
                    item.toMoment = this.$helpers.getMomentFromString(item.to);
                    
                    tstoreevents[data[i].id] = item;
                    
                }
                this.storeEventMap = tstoreevents;
            },
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .fa-custom-header {
        display: inline-block;
        margin: 0 10px;
        margin-top: 0px;
        margin-top: 0px;
        cursor: pointer;
        -webkit-box-shadow: 0 0 0 1.4px var(--contrast-5);
        box-shadow: 0 0 0 1.4px var(--contrast-5);
        border-radius: 100px;
        height: 30px;
        width: 30px;
        -webkit-transition: .2s;
        transition: .2s;
        float: initial;
    }

    .main-container {
        position: absolute;
        height: 100%;
        left: 0;
        width: 100%;
        
       
    }
    .template-view{
        position: relative;
        height: 100%;
       
    }

    .template-view > .header{
        background: var(--contrast-1);
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 60px;
        text-align: center;
        z-index: 2;

    }
    .template-view > .header > .button.filter{

        float: initial;
        display: inline-block;
        margin: 0 10px;
        transform: translateY(1px);

    }
     /* 
    .options{
        display: inline-block;
        margin: 0 5px;
        margin-top: 20px;

    } */

    .event-select {
        width: 15%;
        height: 21px;
        line-height: 1 !important;
        font-size: 12px !important;
        padding: .01rem 0.05rem .01rem 0.1rem !important;
        border: 1px solid var(--contrast-5);
        font-weight: 700;
        background-color: var(--contrast-1);
        transform: translateY(4px) !important;
        border-radius: 5px;
    }

    .vertical-center {
        display: inline-block;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }
    .options{
       
        margin: 0 5px;
        
    } 

    .options .label{
        text-align: center;
        border-radius: 5px;
        transition: .2s;
        height: 20px;
        width: 25px;
        border: 1px solid var(--contrast-5);
        border-right: none;
        border-radius: 0;
        line-height: 130%;
        cursor: pointer;
    }
    
    .label-label{
        background: var(--contrast-6);
        width: 50px !important;
        cursor: default !important;
    }
    .options .label:first-child{
        border-radius: 5px 0 0 5px;
    }
    .options .label:last-child{
        border-radius: 0 5px 5px 0;
        border-right: 1px solid var(--contrast-5);
    }
    
    .widelabel  {
        width: 30px !important;
    }

    .grid{
        padding-top:40px;
        text-align: center;
        position: relative;
        height: 100%;
        overflow-y: scroll;
        overflow-x: hidden;
        
    }

    .grid > .header{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        box-shadow: inset 0 -2px 0 -1px #d5d5d5;
        z-index: 2;
        padding-left: 10px;
    }

    .group{
        margin-bottom: 10px;
    }

    .group > .header{
        width: 230px;
        height: 19px;
        background: #6d8d23;
        border-radius: 50px;
        position: relative;
        z-index: 2;
        margin-left: 5px;
    }

    .group > .header .label{
        color: white;
        font-size: 13px;
        padding-left: 20px;
    }

    .group > .header .fa-stack{
        position: absolute;
        right: -10px;
        transform: scale(0.55);
        top: -4px;
        margin: 0;
        cursor: pointer;
    }


    .group > .header .fa-stack > *{
        pointer-events: none;
    }

    .group > .header .fa-stack.add{
        right: 6px;
    }
    .group > .header .fa-stack *:not(.fa-circle){
        color: #6d8d23;
    }
    .group > .header .fa-stack .fa-circle{
        color: #e5e5e5;
    }
    .group > .header .fa-stack:hover .fa-circle{
        color: #707070 !important;
    }
    .group > .header .fa-stack:hover *:not(.fa-circle):not(.fa-arrows-alt){
        color: #e5e5e5 !important;
    }
    .group > .header .fa-stack.drag{
        right: initial;
        left: -10px;
    }
    .group > .header .fa-stack.drag .fa-arrows-alt{
        line-height: 130%;
        font-size: 20px;
        color: white;
    }

    .group > .header .fa-stack.drag .fa-circle{
        display: none;
    }


    .t-row{
        position: relative;
        width: calc(100% - 215px);
        padding: 5px;
        margin-left: 260px;
        height: 45px;
    }

    .grid .templatedisplay{
        position: absolute;
        top: 0;
        left: -245px;
        height: 46px;
        margin-bottom: 5px;
        padding-left: 45px;
        width: 201px;
        box-shadow: inset 0px -2px 0 -1px var(--contrast-6);
        z-index: 3;
    }

    .grid .t-row:hover .templatedisplay {
        background: var(--contrast-2);
        border-radius: 0;
        border-top-left-radius: 100px;
        border-bottom-left-radius: 100px;
        box-shadow: none;
    }

    .templatedisplay .picture {
        background-size: 100%;
        position: absolute;
        height: 30px;
        width: 30px;
        left: 5px;
        top: 7px;
        border-radius: 33px;
    }

    .templatedisplay .name {
        font-size: 13px;
        color: var(--contrast-5);
        text-align: left;
        height: 15px;
        white-space: nowrap;
        font-weight: 800;
        margin-top: 15px;
        margin-left: 0px;
        font-family: DistrictProBold;
    }
    
    .event-info, .timeframe-popup, .drag-info, .drag-group{
        position: fixed;
        margin: auto;
        display: inline-block;
        background: white;
        box-shadow: 4px 4px 5px 3px var(--contrast-6);;
        pointer-events: none;
        width: fit-content;
        padding: 5px;
        border-radius: 5px;
        opacity: 1;
    }

    .drag-group{
        background: none;
        box-shadow: none;
        z-index: 100;
        pointer-events: none;
    }

    .event-info .header{
        position: relative;
        width: 100%;
        font-weight: 600;
        text-align: center;
    }

    .event-info .description{
        position: relative;
        width: 100%;
        text-align: center;
    }
    .timeframe-popup{
        pointer-events: initial;
        z-index: 3;
    }

    .timeframe-popup .button{
        position: relative;
        font-weight: 600;
        text-align: center;
        margin: 5px 15px;
        width: 120px;
        display: block;
        height: 18px;
        border-radius: 100px;
        line-height: 100%;
    }

    .timeframe-popup .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }



    .time-marks{
        pointer-events: none;
        position: fixed;
        left: 260px;
        width: calc(100% - 258px);
        height: 100%;
        z-index: -1;
        padding: 0;
        white-space: nowrap;
    }

    .time-marks .label{
        position: absolute;
        top: -20px;
        left: -15px;
        width: 30px;
        z-index: 10;
        text-align: center;
    }

    .time-marks .mark{
        text-align: center;
        position: relative;
        width: calc(100% / 24);
        height: 100%;
        display: inline-block;
        box-shadow: inset 2px 0px 0 -1px var(--contrast-6);
        background: none;
    }

    .timeframe{
        position: absolute;
        height: calc(100% - 10px);
        background: #cccccc;
        z-index: 0;
        border-radius: 5px;
        cursor: pointer;
        min-width: 5px;
    }

    .timeframe .handle{
        position: absolute;
        top: 0;
        bottom: 0;
        height: 100%;
        width: 15px;
        margin: auto;
        cursor: col-resize;
        color: #9f9f9f;
        text-align: center;
        transition: .2s;
        opacity: 0;
    }
    .timeframe .label{
        top: 0px;
        left: 5px;
        color: #404040;
        text-align: center;
        font-size: 10px;
        margin: 0 5px;
        float:left;
    }

    .timeframe .label.end{
        right: 5px;
        left: initial;
        float: right;
    }


    .timeframe .handle .inner{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        background: #9f9f9f;
        width: 2px;
        height: calc(100% - 20px);
        pointer-events: none;
    }

    .timeframe:hover .handle{
        opacity: 1;
    }

    .handle.start{
        left: -12px;

    }

    .handle.end{
        right: -12px;
    }
    .timeframe .handle.end{
    }

    .grid .backdrop{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 230px;
        background: var(--bg);
        -webkit-box-shadow: 0 0 30px  var(--bg);
        box-shadow: 0 0 15px 10px  var(--bg);
        z-index: 2;
        pointer-events: none;
    }

    .scrollbar-container{
        position: relative;
        width: 100%;
        overflow-x: hidden;
        
    }
    .loading{
        filter: none !important;
        position:absolute;
        box-sizing:content-box;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100vh);
        background: rgba(0,0,0,.5);
        z-index: 10;
    }
    .loading .fa-spinner{
        position:absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 50px;
        height: 50px;
        font-size: 50px;
        color: var(--contrast-3);
        animation-name: spin;
        animation-duration: 2000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }
    @keyframes spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(360deg);
        }
    }

    .t-row .bottom-line{
        box-shadow: inset 0px 2px 0 -1px var(--contrast-6);;
        height: 1px;
        position: absolute;
        bottom: 0px;
        width: calc(100% + 245px);
        left: -245px;
    }

    .bottom-line{
        box-shadow: inset 0px 2px 0 -1px var(--contrast-6);;
        height: 1px;
        position: relative;
        bottom: 0px;
        width: calc(100% + 245px);
        left: -245px;
    }

    .refresh:hover{
        background: #6c8d25;
    }

    .fa-refresh{
        font-size: 18px;
        -webkit-transform: translate(0px, 5px);
        transform: translate(0px, 5px);
    }

    .fa-refresh{
         color: var(--contrast-5);
     }

    .fa-refresh:before{
        content: '\f021';
    }

    .group.show-drag-area:not(.group-dragged){
        padding-top: 20px;
    }
    .group .drag-catch-area{
        display: none;
    }
    .group .drag-catch-area.last{
        display: none;
    }

    .group.show-drag-area:not(.group-dragged) .drag-catch-area{
        display: inline-block;
        width: 230px;
        height: 19px;
        left: 5px;
        margin-top: -45px;
        background: var(--contrast-2);
        border-radius: 50px;
        position: absolute;
        z-index: 5;
    }
    .group .drag-catch-area.last{
        display: none;
    }
    .group.show-drag-area-last
    {
        padding-bottom: 20px;
    }
    .group.show-drag-area-last .drag-catch-area.last{
        display: inline-block;
    }
    .group.show-drag-area:not(.group-dragged) .drag-catch-area.last{
        margin-top: 4px;
    }
    .group.show-drag-area:not(.group-dragged):hover .drag-catch-area{
        box-shadow: inset 0 0 0 1px var(--contrast-2);
        background: none;
    }

    .group.sub-spot.show-drag-area:not(.group-dragged) .drag-catch-area{
        width: 210px;
        left: 25px;
    }

    .group.sub-spot.show-drag-area:not(.group-dragged):hover .drag-catch-area{
        box-shadow: inset 0 0 0 1px var(--contrast-2);
        background: none;
    }

    .group-dragged{
        opacity: .5;
    }

    .group.sub-spot > .header{
        width: 210px;
        margin-left: 25px;
    }

    .group.sub-spot  .template{
        width: 181px;
        left: -225px;
    }


    .positions-filter, .group-filter, .year-day-filter {
        position: absolute;
        top: 4px;
        left: 30px;
        z-index: 3;
    }

    .group-filter {
        left: 80px;
    }

    .year-day-filter {
        left: 140px;
    }

    .timeframe .fa-calendar-alt{
        color: #e86e13;
        position: absolute;
        top: -5px;
        right: -5px;
        cursor: pointer;
    }

    .year-date-only .label{
        color: white;
        border-radius: 100px;
        background: #e86e13;
        padding: 0 5px;
        margin: 0 0px;
    }

    .grid > .header > .add {
        position: absolute;
        left: 190px;
        top: 8px;
        margin: 0;
        transform: scale(0.6);
        cursor: pointer;
    }
    .grid > .header > .add .fa-plus {
        transform: scale(0.7);
    }
    .grid > .header > .add .fa-circle {
        color: #6d8d23;
    }

    .templatedisplay .remove {
        position: absolute;
        right: 5px;
        top: 13px;
        margin: 0;
        transform: scale(0.5);
        cursor: pointer;
    }
    .templatedisplay .remove .fa-minus {
        transform: scale(0.8);
    }
    .templatedisplay .remove .fa-circle {
        color: #e51c50;
    }


    .time-marks.weekly .label{
        position: absolute;
        top: -20px;
        left: 0;
        right: 0;
        width: 50px;
        text-align: center;
        margin: auto;
    }


</style>
